import { create } from "zustand";

const useAppStore = create((set, get) => ({
  userData: {},
  contentWidth: 0,
  firmID: "TestingFirm2025",
  orders: {},
  receivableRequests: {},
  hideSideBar: false,
  modal: false,
  setModal: (modal) => set({ modal }),
  setHideSideBar: (hideSideBar) => set({ hideSideBar }),

  setUserData: (userData) => set({ userData, firmID: userData.firmID }),
  setContentWidth: (width) => set({ contentWidth: width }),
  clearUserData: () => set({ userData: {}, firmID: null, root: {}, firmData: {} }),
  setOrders: (orders) => set({ orders }),
  setReceivableRequests: (receivableRequests) => set({ receivableRequests }),
}));

export default useAppStore;
